import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppSettings, APP_SETTINGS } from 'src/app/settings';
import { EncryptionService } from 'src/app/service/encryption.service';

@Injectable({
    providedIn: 'root'
})

export class ForumApiService {
    constructor(
      private http: HttpClient,
      @Inject(APP_SETTINGS) private settings: AppSettings,
      private encryptionService: EncryptionService) {  
    }

    gatewayUrl: any = this.encryptionService.decryptUsingAES_256(this.settings.gatewayUrl);
    private gatewayUrlheaders = new HttpHeaders({
        'Ocp-Apim-Subscription-Key': this.encryptionService.decryptUsingAES_256(this.settings.ocpApimSubscriptionKey)
    });

    tradeBaseAPIURL: any = this.encryptionService.decryptUsingAES_256(this.settings.tradeBaseAPIUrl);
    private tradeBaseAPIheaders = new HttpHeaders({
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': this.encryptionService.decryptUsingAES_256(this.settings.tradeApiOcpKey)
    });

    gatewayAPIURL: any = this.encryptionService.decryptUsingAES_256(this.settings.gatewayAPIUrl);
    private gatewayAPIheaders = new HttpHeaders({
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': this.encryptionService.decryptUsingAES_256(this.settings.gatewayApiOcpKey)
    });

    boApiUrl: any = this.encryptionService.decryptUsingAES_256(this.settings.gatewayBoAPIUrl);
    accessTokenUrl: any = this.encryptionService.decryptUsingAES_256(this.settings.accessTokenForJwtUrl);

    async getPortalId(orgId:string): Promise<any> {
        try {
            // let queryParams = new HttpParams();
            // queryParams = queryParams.append('orgId', orgId); 

            let OrgnizationId = 'orgId=' + orgId;

            let options = { headers: this.gatewayUrlheaders };

            const data = await this.http.get(this.gatewayUrl + '/helpCenters?' + OrgnizationId, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await getPortalId : ' + error);
            return error;
        }
    }

    async searchByString(portalNo:string, searchString:string, fromNo:string, limitNo:string): Promise<any> {
        try {
            const params = new HttpParams({
                fromObject: {
                    portalId: portalNo,
                    searchStr: searchString,
                    from: fromNo,
                    limit: limitNo,
                }
              });
            let options = { headers: this.gatewayUrlheaders };
            const data = await this.http.get(this.gatewayUrl + '/search?' + params, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await searchByString : ' + error);
            return error;
        }
    }

    async knowledgeBase(include:string, portalId:string): Promise<any> {
        try {
            const params = new HttpParams({
                fromObject: {
                    include: include,
                    portalId: portalId
                }
              });
            let options = { headers: this.gatewayUrlheaders };
            const data = await this.http.get(this.gatewayUrl + '/27465000000140056/categoryTree?' + params, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await knowledgeBase : ' + error);
            return error;
        }
    }

    async articalList(portalId:string, categoryId:string, from:string, limit:string, sortBy:string, locale:string): Promise<any> {
        try {
            const params = new HttpParams({
                fromObject: {
                    portalId: portalId,
                    categoryId: categoryId,
                    from: from,
                    limit: limit,
                    sortBy: sortBy,
                    locale: locale
                }
              });
            let options = { headers: this.gatewayUrlheaders };
            const data = await this.http.get(this.gatewayUrl + '/Articallist?' + params, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await articalList : ' + error);
            return error;
        }
    }

    async indivisualFaq(portalId:string, categoryId:string): Promise<any> {
        try {
            const params = new HttpParams({
                fromObject: {
                    portalId: portalId
                }
              });
            let options = { headers: this.gatewayUrlheaders };
            const data = await this.http.get(this.gatewayUrl + '/kbArticles/'+ categoryId + '?' + params, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await indivisualFaq : ' + error);
            return error;
        }
    }

    async frequentlyAskedQuestions(portalId:string, categoryId:string, from:string, limit:string, sortBy:string, locale:string): Promise<any> {
        try {
            const params = new HttpParams({
                fromObject: {
                    portalId: portalId,
                    categoryId: categoryId,
                    from: from,
                    limit: limit,
                    sortBy: sortBy,
                    locale: locale
                }
              });
            let options = { headers: this.gatewayUrlheaders };
            const data = await this.http.get(this.gatewayUrl + '/Articallist?' + params, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await frequentlyAskedQuestions : ' + error);
            return error;
        }
    }

    async disLikeArticle(portalId:string, articleId:string): Promise<any> {
        try {
            const params = new HttpParams({
                fromObject: {
                    portalId: portalId
                }
              });
            let options = { headers: this.gatewayUrlheaders };

            const data = await this.http.post(this.gatewayUrl + '/' + articleId + '/dislike', { },
                        { headers: options.headers, params: params }).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await disLikeArticle : ' + error);
            return error;
        }
    }

    async likeArticle(portalId:string, articleId:string): Promise<any> {
        try {
            const params = new HttpParams({
                fromObject: {
                    portalId: portalId
                }
              });
            let options = { headers: this.gatewayUrlheaders };

            const data = await this.http.post(this.gatewayUrl + '/' + articleId + '/like', { },
                        { headers: options.headers, params: params }).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await likeArticle : ' + error);
            return error;
        }
    }

    async CheckLoginResponse(reqBody: any): Promise<any> {
        try {
        let options = { headers: this.tradeBaseAPIheaders, withCredentials: true };
          const data = await this.http.post(this.tradeBaseAPIURL + 'CheckLoginResponse', reqBody, options).toPromise();
          return data;
        }
        catch (error) {
          console.log('Error fetching data with Async/Await CheckLoginResponse : ' + error);
          return error;
        }
    }

    async createToken(reqBody: any): Promise<any> {
        try {
            let options = { headers: this.gatewayAPIheaders };
            const data = await this.http.post(this.gatewayAPIURL + '/CRM/MainProj/Token', reqBody, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await createToken : ' + error);
            return error;
        }
    }

    async ticketGeneration(reqBody: any): Promise<any> {
        try {
            let options = { headers: this.gatewayAPIheaders };
            const data = await this.http.post(this.gatewayAPIURL + '/CRM/MainProj/CreateTicket', reqBody, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await ticketGeneration : ' + error);
            return error;
        }
    }

    async clientPersonalDetails(auth: string, reqBody: any): Promise<any> {
        try {
            const boAPIheaders = {
                'Content-Type': 'application/json',
                'ocp-apim-subscription-key': this.encryptionService.decryptUsingAES_256(this.settings.BoAPIUrlOcpKey),
                'authorization' : auth
            }
            let options = { headers: boAPIheaders };
            const data = await this.http.post(this.boApiUrl + 'ClientPersonalDetails', reqBody, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await ClientPersonalDetails : ' + error);
            return error;
        }
    }


    async getAccessTokenForJwt(reqBody: any): Promise<any> {
        try {
            const accessTokenHeaders = {
                'Authorization' : 'CRM-oauthtoken KT11FL9PliZLB4cLumsRZ9GzmwDOVLiUZb46Kw1XU0U='
            }
            let options = { headers: accessTokenHeaders };
            const data = await this.http.post(this.accessTokenUrl + 'JwtApiToken', reqBody, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await getAccessTokenForJwt : ' + error);
            return error;
        }
    }

    async getJwtToken(accessToken, reqBody: any): Promise<any> {
        try {
            const accessTokenHeaders = {
                'Authorization' : 'CRM-oauthtoken ' + accessToken
            }
            let options = { headers: accessTokenHeaders };
            const data = await this.http.post(this.accessTokenUrl + 'JwtTokenV1', reqBody, options).toPromise();
            return data;
        }
        catch (error) {
            console.log('Error fetching data with Async/Await getJwtToken : ' + error);
            return error;
        }
    }

}